import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { useStyles } from './useStyles';
import { useLanguage } from '../../hooks/useLanguage/useLanguage';

export const FlightTaskRoute = memo(({ num, numEng, cancel = false, date, route }) => {
    const classes = useStyles();
    const { t: translate } = useTranslation();
    const { isEng } = useLanguage();

    return (
        <span className={classes.container}>
            <span className={classes.number}>{isEng ? numEng || num : num}</span>
            {cancel && <span className={classes.cancel}>{` (${translate('flightTaskPage.canceled')}) `}</span>}
            <span className={classes.route}>{date && moment.utc(date).format(' DD.MM.YYYY')}</span>
            {route && ` ${route}`}
        </span>
    );
});
